import './warningMessage.scss';
import warningIcon from "assets/images/warningIcon.svg";

interface WarningMessageProps {
    message: string;
}


const WarningMessage = ({ message }: WarningMessageProps) => {
    return (
        <div className='warning-message'>
            <img src={warningIcon} alt='warning icon'/>
            <p>{message} </p>
        </div>
    )
}

export default WarningMessage;